'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InfoPartition = require('../InfoPartition/InfoPartition');

var _InfoPartition2 = _interopRequireDefault(_InfoPartition);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CookiePolicy = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CookiePolicy, _Component);

  function CookiePolicy() {
    (0, _classCallCheck3.default)(this, CookiePolicy);
    return (0, _possibleConstructorReturn3.default)(this, (CookiePolicy.__proto__ || (0, _getPrototypeOf2.default)(CookiePolicy)).apply(this, arguments));
  }

  (0, _createClass3.default)(CookiePolicy, [{
    key: 'render',


    /* eslint-disable max-len */
    value: function render() {
      var t = this.props.t;

      var text = {
        title: t('Cookie Policy'),
        preKey: 'cookie-policy_',
        body: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'p',
            null,
            t('When you first use this site, the cookies shall be blocked but once you take any action at all, you will consent to the cookies being enabled. You will receive notification to this effect.')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('Cright respects the privacy of all visitors to our website. This Cookie Policy outlines our policy concerning the use of cookies on this website. We may update our Cookie Policy from time to time to reflect any changes in technology or legislation which may affect the way in which cookies are used by us and how you as a user, can manage them and we will publish any updates on this website.')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('What are Cookies?')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('Cookies are small pieces of information that a website sends to your computer for record-keeping purposes. This information is stored in a file on your computer\'s hard drive. Cookies make web-surfing easier for you by saving your preferences so that we can use the saved information to facilitate your use of our website when you return to the website. The use of cookies is an industry standard, and as such, you will find that most major websites use them. By showing how and when users use the website, cookies help us see which areas of the website are popular and which are not. Many improvements and updates to the website are based on such data as total number of visitors and pages viewed. This information is most easily tracked with cookies.')
          ),
          _react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'Most cookies expire after a defined period of time, or you can delete your cookie file at any time. Most web browsers are initially set up to accept cookies. You can reset your web browser to disable cookies or to indicate when a cookie is being sent. However, note that some parts of our Service may not function properly or may be considerably slower if you refuse cookies. Additional information about cookies, including opting-out of certain cookies, please visit: {{siteLink}}.',
            siteLink: _react2.default.createElement(
              'a',
              { target: '_blank', href: 'http://www.aboutcookies.org', rel: 'noopener noreferrer' },
              'www.aboutcookies.org'
            )
          })
        ),
        articles: [{
          key: 'cookie-we-use_',
          header: t('Which Cookies Do We Use'),
          bodies: [t('When you use this website the following types of cookies can be set on your device:'), t('1. Strictly Necessary Cookies'), t('These cookies enable Services that you have specifically asked for. These cookies do not usually contain any personally identifiable information and are typically set by websites to provide services such as eCommerce and log in facilities. For example, these cookies identify you as being signed in to websites and enable you to remain logged in throughout your visit;'), t('Our content management system (CMS) uses session cookies that cannot be disabled.'), t('2. Performance Cookies'), t('These cookies are used to collect statistical information about visitors of the website and the pages they view.'), t('These cookies do not collect information that identifies a visitor. The information these cookies collects is aggregated and used anonymously. We use these cookies to understand what content is popular which helps us to improve our website.'), t('3. Functional Cookies'), t('These cookies allow the website to remember choices you make and provide enhanced and more personal features. Some examples of such features include:'), t(' - Remembering your preferences and settings such as redirect to mobile version of the site when you are browsing with a smart phone'), t(' - Remembering your favourites when browsing particular websites'), t('If you have an account on a particular website, a cookie on your computer lets the website remember your user name and email address so you don\'t have to enter it again when you are commenting or writing a review.'), t('4. Targeting and Advertising Cookies'), t('These cookies are used to deliver advertising that is more relevant to you and your interests. They are also used to limit the number of times you see an advertisement as well as help measure the effectiveness of the advertising campaign. They are usually placed by advertising networks with our permission. They remember that you have visited a website; this information is shared with other organisations such as advertisers. Often targeting or advertising cookies will be linked to site functionality provided by the other organisation. Some examples of services that use these types of cookies include Google AdSense or DoubleClick. If you wish to opt-out of targeting and advertising cookies please visit: www.youronlinechoices.com/ie/your-ad-choices'), t('5. Other Third Party Cookies'), t('Some cookies that have been set on our websites are not related to Cright. When you visit a page with content embedded from, for example, YouTube or Facebook, these service providers may set their own cookies on your web browser. We do not control the use of these cookies and cannot access them due to the way that cookies work, as cookies can only be accessed by the party who originally set them. You should check the third party websites for more information about these cookies.'), t('')]
        }]
      };

      return _react2.default.createElement(_InfoPartition2.default, { text: text });
    }
    /* eslint-enable max-len */

  }]);
  return CookiePolicy;
}(_react.Component), _class2.propTypes = {
  t: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = CookiePolicy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/CookiePolicy/CookiePolicy.js
// module id = 2022
// module chunks = 1